<template>
  <v-select
    :id="`select-${field.id}`"
    :label="field.name"
    :items="field.options.sort((a, b) => a.order - b.order)"
    item-title="name"
    item-value="name"
    :multiple="field.type === FieldTypeEnum.MultiSelect"
    :model-value="computedValue"
    :hint="field.description"
    :rules="fieldRules"
    @update:model-value="onInput"></v-select>
</template>

<script setup lang="ts">
import { FieldTypeEnum, IEntryFieldDTO } from '@/dtos';
import { rules } from '@/helpers';
import { ref, computed, watch } from 'vue';

const props = defineProps<{
  field: IEntryFieldDTO;
  modelValue?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', fieldId: string, value: string): void;
}>();

const field = props.field;

const fieldRules = ref<((value: string) => true | string)[]>([]);
const computedValue = computed(() => {
  return props.modelValue ? props.modelValue.split('|') : [];
});

const onInput = (value: string | string[] | null) => {
  const finalValue = Array.isArray(value) ? value.join('|') : (value ?? '');
  emit('update:modelValue', field.id, finalValue);
};

watch(
  () => field,
  () => {
    fieldRules.value = [];
    if (field.is_required) {
      fieldRules.value.push(rules.required);
    }
  },
  { immediate: true },
);
</script>
